module.exports = __webpack_public_path__ + "img/dash.7eb53d4c.svg";